import { AppBundle } from 'api/optimalprint-sdk.d';

type BundleGroup = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IBundleGroup;

const getSelectedBundleItems = (bundleGroup: BundleGroup, selectedProducts: number[]) =>
  bundleGroup.items?.filter((item) => selectedProducts.indexOf(item.productId) !== -1);

export default getSelectedBundleItems;
